import { AccessToken, RefreshToken } from './../commonModels/tokenStorage';
import TokenStorage from '../commonModels/tokenStorage';
import googleApi from '../../gateways/api/googleApi';
import { GoogleEmail, GoogleAccessToken } from '../../domain/google';
import { UserId } from '../../domain/user';
import tracker from '../../gateways/tracker/tracker';
import { Either } from '../../utils/either';
import { UnknownNetworkError } from '../commonModels/apiResponse';
import i18n from '../../R/string/i18n';
import { WA_SERVICE } from '../../domain/waService';

export interface GoogleRegisterApiSuccess {
  sessionType: 'signup' | 'signin';
  accessToken: AccessToken;
  refreshToken: RefreshToken;
  userId: UserId;
  googleAccessToken: GoogleAccessToken;
  googleEmail: GoogleEmail;
}

interface RegisterSuccess {
  sessionType: 'signup' | 'signin';
  googleEmail: GoogleEmail;
  googleAccessToken: GoogleAccessToken;
}

export class GoogleRegisterError implements Error {
  name = 'GoogleRegisterError';
  constructor(readonly message: string) {}
}

const register =
  (tokenStorage: TokenStorage) =>
  async (
    accessToken: string,
    waService: WA_SERVICE
  ): Promise<
    Either<GoogleRegisterError | UnknownNetworkError, RegisterSuccess>
  > =>
    (await googleApi.register(accessToken, waService)).map(
      ({
        accessToken,
        refreshToken,
        sessionType,
        userId,
        googleEmail,
        googleAccessToken
      }) => {
        tokenStorage.setRefreshToken(refreshToken);
        tokenStorage.setAccessToken(accessToken);

        if (sessionType === 'signup') {
          tracker.startTracking(userId);
          tracker.trackSocialAccountRegistration(userId);
        } else {
          tracker.resumeTracking(userId);
        }

        return {
          sessionType,
          googleEmail,
          googleAccessToken
        };
      }
    );

export interface GoogleConfirmResult {
  type: 'emailSameAsGmail' | 'emailDifferentFromGmail';
}

export class GoogleConfirmGeneralError implements Error {
  name = 'GoogleConfirmEmailAlreadyRegistered';
  constructor(readonly message: string) {}
}

export class GoogleConfirmEmailAlreadyRegisteredError implements Error {
  name = 'GoogleConfirmEmailAlreadyRegistered';
  message = i18n.socialLoginEmailAlreadyRegistered();
}

export type GoogleConfirmErrorTypes =
  | GoogleConfirmEmailAlreadyRegisteredError
  | UnknownNetworkError
  | GoogleConfirmGeneralError;

const confirm = async (email: GoogleEmail, token: GoogleAccessToken) =>
  googleApi.confirm(email, token);

export default {
  register,
  confirm
};
